// src/components/Modelo/Breadcrumb.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import styles from './Breadcrumb.module.scss';

const normalizeSlug = (str) =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-');

const Breadcrumb = ({ linea, serie }) => {
  const navigate = useNavigate();
  const lineaNombre = linea?.nombre || 'Sin línea';
  const serieNombre = serie?.nombre || 'Sin serie';
  const lineaSlug = normalizeSlug(linea?.slug || lineaNombre);

  const handleClickSerie = () => {
    const idLinea = linea?.documentId;
    if (!idLinea) return;
    navigate('/productos', {
      state: { selectedLineaId: idLinea, selectedSerie: serie },
    });
  };

  const handleLineaClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'modelo_click_breadcrumb',
          event_category: null,
          event_label: null,
          value: null,
          slug: lineaSlug,
        },
      });
    }
  };

  return (
    <nav className={styles.breadcrumb}>
      <Link to="/productos" className={styles.link}>Productos</Link>
      <span className={styles.divider}>&gt;</span>
      <Link
        to={`/productos/${lineaSlug}`}
        className={styles.link}
        onClick={handleLineaClick}
      >
        {lineaNombre}
      </Link>
      <span className={styles.divider}>&gt;</span>
      <button
        type="button"
        className={`${styles.link} ${styles.last}`}
        onClick={handleClickSerie}
      >
        {serieNombre}
      </button>
    </nav>
  );
};

export default Breadcrumb;